import apiClient from 'hub-http/clients/apiClient';
export const fetchPaymentsAccountEligibility = () => apiClient.get('payments/v1/payment-accounts/eligibility');
export const fetchPaymentsAccountShippingAddressEligibility = () => apiClient.get('monetization/v3/payments/eligible');
export const fetchPaymentsAccountStatus = () => apiClient.get('monetization/v3/payments/status');